/* TBH quick add for collection grids.
   Dawn's built-in quick-add modal needs Dawn's product page markup, which our custom product page
   doesn't have, so this handles the "Add to cart +" strip instead:
   one variant -> added straight away; several variants (100/200/300gm) -> small picker sheet. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function symbol() {
    var el = document.querySelector('#product-grid .price-item, .tbh-pp__price, .tbh-pp__card-price, .tbh-nl__price, .tbh-ml__price span');
    var m = el && el.textContent.replace(/From/i, '').trim().match(/^([^\d\s]+)/);
    return m ? m[1] : '₹';
  }
  function money(paise) {
    var n = paise / 100;
    return symbol() + ' ' + n.toLocaleString('en-IN', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var toastTimer;
  function toast(msg, ok) {
    var t = document.querySelector('.tbh-qa-toast') || document.body.appendChild(el('div', 'tbh-qa-toast'));
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (ok ? '<a href="' + root + 'cart">View cart</a>' : '');
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3500);
  }

  function refreshCartBubble() {
    return fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = s && s['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (!html || !target) return;
        var tmp = new DOMParser().parseFromString(html, 'text/html');
        var fresh = tmp.querySelector('.cart-count-bubble');
        var current = target.querySelector('.cart-count-bubble');
        if (fresh && current) current.replaceWith(fresh);
        else if (fresh) target.appendChild(fresh);
        else if (current) current.remove();
      })
      .catch(function () {});
  }

  function add(variantId, btn) {
    if (btn) btn.classList.add('is-busy');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { closeSheet(); refreshCartBubble(); toast('Added to cart', true); })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add to cart. Please try again.', false); })
      .finally(function () { if (btn) btn.classList.remove('is-busy'); });
  }

  var sheet, backdrop;
  function closeSheet() {
    if (sheet) { sheet.remove(); sheet = null; }
    if (backdrop) { backdrop.remove(); backdrop = null; }
    document.documentElement.classList.remove('tbh-qa-open');
  }

  function openSheet(p) {
    closeSheet();
    backdrop = document.body.appendChild(el('div', 'tbh-qa-backdrop'));
    backdrop.addEventListener('click', closeSheet);
    sheet = document.body.appendChild(el('div', 'tbh-qa-sheet'));
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Choose an option for ' + p.title);
    var optName = (p.options && p.options[0] && (p.options[0].name || p.options[0])) || 'Option';
    var html = '<div class="tbh-qa-sheet__head"><div><p class="tbh-qa-sheet__title">' + esc(p.title) + '</p>' +
      '<p class="tbh-qa-sheet__label">Select ' + esc(optName) + '</p></div>' +
      '<button type="button" class="tbh-qa-sheet__close" aria-label="Close">&times;</button></div><div class="tbh-qa-sheet__opts">';
    p.variants.forEach(function (v) {
      var cmp = v.compare_at_price && v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '';
      html += '<button type="button" class="tbh-qa-opt" data-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="tbh-qa-opt__name">' + esc(v.title) + '</span>' +
        '<span class="tbh-qa-opt__price">' + (v.available ? money(v.price) + cmp : 'Sold out') + '</span></button>';
    });
    html += '</div>';
    sheet.innerHTML = html;
    sheet.querySelector('.tbh-qa-sheet__close').addEventListener('click', closeSheet);
    sheet.querySelectorAll('.tbh-qa-opt').forEach(function (b) {
      b.addEventListener('click', function () { add(Number(b.getAttribute('data-id')), b); });
    });
    document.documentElement.classList.add('tbh-qa-open');
    var first = sheet.querySelector('.tbh-qa-opt:not([disabled])');
    if (first) first.focus();
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#product-grid .quick-add__submit, .tbh-qa-trigger');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var url = btn.getAttribute('data-product-url');
    var form = btn.closest('form');
    var idInput = form && form.querySelector('input[name="id"]');
    if (!url && idInput) return add(Number(idInput.value), btn);
    if (!url) return;
    btn.classList.add('is-busy');
    fetch(url.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var avail = p.variants.filter(function (v) { return v.available; });
        if (p.variants.length === 1) return add(p.variants[0].id, btn);
        if (!avail.length) return toast('Sold out', false);
        openSheet(p);
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { btn.classList.remove('is-busy'); });
  }, true);
})();
